import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import {
  MachineAssignment,
  MachineAssignmentImportCommand,
  MachineAssignmentImportResult,
} from '../../models/commands/machine-assignment-import-command';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class MachineAssignmentProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly apiUrl = `${environment.proxyUrls.productionApi}/api/v1/machine-assignment`;

  getAll(): Observable<ApiResponse<MachineAssignment[]>> {
    return this.httpClient.get<ApiResponse<MachineAssignment[]>>(this.apiUrl, {
      headers: { Accept: 'text/plain' },
    });
  }

  getByDateShift(date: string, shift: number): Observable<ApiResponse<MachineAssignment[]>> {
    const params = new HttpParams().set('date', date).set('shift', String(shift));
    return this.httpClient.get<ApiResponse<MachineAssignment[]>>(`${this.apiUrl}/by-date-shift`, {
      params,
      headers: { Accept: 'application/json' },
    });
  }

  getByCostCenterAndMonth(costCenterCode: string, year: number, month: number): Observable<ApiResponse<MachineAssignment[]>> {
    const params = new HttpParams().set('costCenterCode', costCenterCode).set('year', String(year)).set('month', String(month));
    return this.httpClient.get<ApiResponse<MachineAssignment[]>>(`${this.apiUrl}/by-cost-center-and-month`, {
      params,
      headers: { Accept: 'application/json' },
    });
  }

  import(command: MachineAssignmentImportCommand): Observable<ApiResponse<MachineAssignmentImportResult>> {
    const formData = new FormData();
    formData.append('file', command.file, command.file.name);

    const params = new HttpParams()
      .set('shift', String(command.shift))
      .set('costCenterCode', command.costCenterCode)
      .set('preview', String(command.preview))
      .set('override', String(command.override));

    return this.httpClient.post<ApiResponse<MachineAssignmentImportResult>>(`${this.apiUrl}/import-excel`, formData, {
      params,
      headers: { Accept: 'text/plain' },
    });
  }
}
